import script from "./cardstatusesList.vue?vue&type=script&lang=ts&setup=true"
export * from "./cardstatusesList.vue?vue&type=script&lang=ts&setup=true"

import "./cardstatusesList.vue?vue&type=style&index=0&id=4900a333&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4900a333"]])

export default __exports__